import MultiselectAutocomplete from './MultiselectAutocomplete.component';

export default MultiselectAutocomplete;
